import { legacyToken, handleUnauthorized } from "./operateSso";
import { inspectDownloadResponse, downloadError, isUnauthorizedPayload } from './downloadResponse';
import axios from 'axios'

const request = axios.create({
    baseURL: 'https://kebeidianzi.com/',  //这里是全局统一加上了 后端接口前缀 前缀，后端必须进行跨域配置！
    // baseURL: "http://192.168.1.27:666/",//本地测试地址（方便交叉测试）
    // baseURL: process.env.VUE_APP_API_BASE || "/",//本地测试地址


    timeout: 1000000,
})
//http://119.91.196.193:999/
// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
    if (!isFormData && config.headers['Content-Type'] !== 'multipart/form-data') {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    // 统一附加 JWT（登录时已存入 localStorage.access_token），供后端 jwt_required 鉴权
    const token = legacyToken();
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    async response => {
        let res = response.data;
        // A requested file may actually be a JSON authentication/business error.
        if (['blob', 'arraybuffer'].includes(response.config.responseType)) {
            const error = await inspectDownloadResponse(response);
            if (error) {
                if (error.isAuthError) handleUnauthorized();
                throw error;
            }
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        if (isUnauthorizedPayload(res)) {
            handleUnauthorized();
            return Promise.reject(new Error('登录状态失效，请重试'));
        }
        return res;
    },
    async error => {
        const response = error.response;
        if (response?.status === 401) handleUnauthorized();
        if (response && ['blob', 'arraybuffer'].includes(response.config?.responseType)) {
            const fileError = await inspectDownloadResponse(response)
                || downloadError(response, null, `下载失败（HTTP ${response.status}）`);
            if (fileError.isAuthError && response.status !== 401) handleUnauthorized();
            throw fileError;
        }
        if (response?.status !== 401 && isUnauthorizedPayload(response?.data)) handleUnauthorized();
        return Promise.reject(error)
    }
)

request.defaults.withCredentials = true

export default request
